<template>
	<li>
		<span class="group_thumb">
			<span class="box_thumb"><span class="img_thumb album_regulate"><span class="sr_only">cafe 규제 이미지</span></span></span>
		</span>
		<strong class="tit_gallery">{{ message }}</strong>
		<span class="txt_regulate">
			<a :href="blindArticleUrl" class="link_regulate" v-if="showsBlindArticle">원문보기</a>
			<a :href="restrictionUrl" target="_blank" class="link_regulate box_regulation">규제관련 안내</a>
		</span>
	</li>
</template>

<script>
import {mapState} from 'vuex';

export default {
	props: {
		userid: {type: String, default: ''},
		vldstatus: {type: String}
	},
	computed: {
		...mapState({
			myUserId: 'userId'
		}),
		message() {
			switch (this.vldstatus) {
				case 'D1':
				case 'D2':
					return '관리자에 의해 규제된 글입니다.';
				case 'R2':
					return '정보통신망법 제44조의2에 의해 삭제 조치된 글입니다.';
				case 'R3':
					return '저작권 침해 신고로 접근금지 조치된 글입니다.';
				default:
					return '권리 침해 신고 접수에 의해 임시 조치된 글입니다.';
			}
		},
		isMine() {
			return this.userid === this.myUserId;
		},
		showsBlindArticle() {
			return this.isMine || ['7PVMl', '7PVMY', '70Wum'].includes(this.myUserId);
		},
		blindArticleUrl() {
			return `/_c21_/blind_bbs_read?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}`;
		},
		restrictionUrl() {
			switch (this.vldstatus) {
				case 'D1':
				case 'D2':
					return '//top.cafe.daum.net/_c21_/guide?for=restriction_rule';
				case 'R2':
					return '//cs.daum.net/redbell/right/libelGuide.html';
				case 'R3':
					return '//cs.daum.net/redbell/right/copyrightGuide.html';
				default:
					return '//cs.daum.net/redbell/right/libelGuide.html';
			}
		}
	}
}
</script>
